import {makeStyles, Theme} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    borderRadius: 20,
    border: "1px solid #E2E8F0",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
    backgroundColor: "#FFFFFF",
    overflow: "visible",
    [theme.breakpoints?.down("sm")]: {
      display: "none",
    },
  },
  mobileListView: {
    display: "none",
    [theme.breakpoints?.down("sm")]: {
      display: "block",
      padding: "20px 10px",
    },
  },
  mobileCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    border: "1px solid #E2E8F0",
    padding: 16,
    marginBottom: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.02)",
  },
  mobileCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  mobileCardBody: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginBottom: 14,
    backgroundColor: "#F8FAFC",
    padding: "12px 14px",
    borderRadius: 10,
  },
  mobileCardRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  mobileCardActions: {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  paginationContainer: {
    marginTop: 24,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    padding: "16px 24px",
    borderRadius: 16,
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
    [theme.breakpoints?.down("sm")]: {
      flexDirection: "column",
      gap: 12,
      padding: "16px 12px",
      borderRadius: 12,
    },
  },
  btn_add: {
    color: "#2563EB",
    backgroundColor: "#EFF6FF",
    border: "1px solid #BFDBFE",
    borderRadius: 10,
    fontSize: "0.8125rem",
    fontWeight: 700,
    padding: "6px 16px",
    margin: "0 4px",
    cursor: "pointer",
    textTransform: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#2563EB",
      color: "#FFFFFF",
      borderColor: "#2563EB",
      boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)",
    },
  },
  btn_delete: {
    color: "#DC2626",
    backgroundColor: "#FEF2F2",
    border: "1px solid #FCA5A5",
    borderRadius: 10,
    fontSize: "0.8125rem",
    fontWeight: 700,
    padding: "6px 16px",
    marginRight: 4,
    cursor: "pointer",
    textTransform: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#DC2626",
      color: "#FFFFFF",
      borderColor: "#DC2626",
      boxShadow: "0 4px 12px rgba(220, 38, 38, 0.25)",
    },
  },
  root_modal: {
    width: "100%",
    height: "60%",
    display: "flex",
    justifyContent: "center",
  },
  modal__container: {
    width: "100%",
    maxWidth: 560,
    borderRadius: 12,
    backgroundColor: "#fff",
    zIndex: 9,
    display: "flex",
    flexDirection: "column",
    margin: "30px 0",
  },
  modal__header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 24px",
    minHeight: 65,
    borderBottom: "1px solid rgb(235, 235, 235)",
    "& >h6": {
      fontWeight: 700,
      fontSize: 18,
      marginRight: 50,
    },
  },
}));

export default useStyles;
